import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../../../button/button.module';
import { CardModule } from '../../../card/card.module';
import { FloatingMenuModule } from '../../../floating-menu/floating-menu.module';
import { BottomSheetModule } from '../../../bottom-sheet/bottom-sheet.module';
import { IconicModule } from '../../../iconic/iconic.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { ListModule } from '../../../list/list.module';
import { ToolbarModule } from '../../../toolbar/toolbar.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { BasemapGalleryModule } from './components/basemap-gallery/basemap-gallery.module';
import { LayerListModule } from './components/layer-list/layer-list.module';
import { TocComponent } from './toc.component';
import { PortalRenderModule } from 'app/shared/directives/portal-render/portal-render.module';

@NgModule({
  imports: [
    CommonModule,
    CardModule,
    ToolbarModule,
    TooltipModule,
    ListModule,
    IconicModule,
    ButtonModule,
    InputBoxModule,
    FloatingMenuModule,
    BottomSheetModule,
    BasemapGalleryModule,
    LayerListModule,
    PortalRenderModule,
  ],
  declarations: [TocComponent],
  exports: [TocComponent],
})
export class TocModule {}
